import { createFileRoute } from "@tanstack/react-router";
import LandingSectionPage from "@/pages/LandingSectionPage";
import { landingHead } from "@/lib/landingHead";

export const Route = createFileRoute("/agente-ia")({
  head: () => landingHead("aiAgent", "es"),
  component: () => <LandingSectionPage section="aiAgent" routeLang="es" />,
  errorComponent: () => <LandingSectionPage section="aiAgent" routeLang="es" />,
  notFoundComponent: () => <LandingSectionPage section="aiAgent" routeLang="es" />,
});
